import { DecimalPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatTabGroup, MatTabChangeEvent } from '@angular/material/tabs';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router, withDebugTracing } from '@angular/router';
import { MaterialsService } from 'src/app/Services/materials.service';
import { ProjectService } from 'src/app/Services/project.services'; 
import { Materials } from 'Materials';
import { Project, ProjectMaterial } from 'src/app/objects/Project';

import { MatTableDataSource } from '@angular/material/table'; 
import { ProjectMaterialService } from 'src/app/Services/projectMaterials';
import { ProjectImageUploadComponent } from '../project-image-upload/project-image-upload.component';
import { ProjectDrawingUploadComponent } from '../project-drawing-upload/project-drawing-upload.component';
import { ProjectLaborService } from 'src/app/Services/project-labor.service';

import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-project-edit',
  templateUrl: './project-edit.component.html',
  styleUrls: ['./project-edit.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectEditComponent implements OnInit {
  @ViewChild('tabGroup') tabGroup?: MatTabGroup;
 
  constructor(    private route: ActivatedRoute,
    private router: Router, private snackBar: MatSnackBar,
    private materialsService: MaterialsService,
    private projectMaterialService: ProjectMaterialService,
    private projectService: ProjectService,
    private laborService: ProjectLaborService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef) {
      this.form =  this.createFormGroup();   
     }
 
     openImageUpload() {
       this.dialog.open(ProjectImageUploadComponent);
     }

     openDrawingUpload() {
      this.dialog.open(ProjectDrawingUploadComponent);
    }
    public pieChartLabels: string[] = ['Category A', 'Category B', 'Category C'];
    public pieChartData: number[] = [30, 50, 20];
    public pieChartType: string = 'pie';
    
  form: FormGroup;
  ProjectId: number | undefined ;
  projecTasksCount: number | undefined ;
  projecContractorsCount: number | undefined ;
  projectNotesCount: number | undefined ;
  projecRemaingPaymentsCount: number | undefined ;
  isLoadingResults: boolean | undefined; 
  showAvailbleMaterials: boolean | undefined; 
  isMobile= false; 
  project: Project |any;

  items: any[] = [];
  materials: Materials []=[];
  // ProjectMaterials: ProjectMaterial []=[];
  sortProperty: string = 'id';
  sortOrder = 1;
  sortListProperty: string = 'id';
  sortListOrder = 1;
  ProjectObject?: Project []=[];
  
 ProjectMaterialColumns: string[] = ['productName', 'productCategory',  'subCategory', 'productDescription','productPrice','qty','cost','edit'];
 //ProjectMaterialColumns: string[] = ['productName','productPrice','qty','cost'];
 //ProjectMaterialColumns: string[] = ['qty' ];

 
  sum(val: number, col: string, rowIndex: number) {
    this.project.materials[rowIndex][col] = +val;
    this.project.materials[rowIndex].cost = +this.project.materials[rowIndex].productPrice * +this.project.materials[rowIndex].qty;
  }
 
  dataSource!: MatTableDataSource<ProjectMaterial>;
  editedRow: ProjectMaterial | undefined;
  // project: Project = {
  //   id: 0,
  //   title: '',
  //   projectDescription: '',
  //   totalProjectPrice: 0,
  //   projectBids: ProjectBid[] =[],
  //   contractors: ProjectContractor[];
  //   equipment: ProjectEquipment[];
  //   overhead: ProjectOverhead[];
  //   materials: ProjectMaterial[];
  //   fees: ProjectFee[];
  //   plans: ProjectPlan[];




    // projectBids: [],
    // contractors: [],
    // equipment: [],
    // overhead: [],
    // materials: [],
    // fees: [],
    // plans: []
  
 

  ngOnInit(): void {
    this.isLoadingResults = true;
    this.route.paramMap.subscribe((params) => {
      const projectId = parseInt(params.get('id') || '0', 10);

      if (projectId > 0) {
        this.loadProject(projectId);
      }
    });

    this.checkisMobile();

  }

  checkisMobile() { 
     
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 
    if(width < 768)
    {this.isMobile = true;
    }
      
      else
    {this.isMobile = false;}
    
    
  } 
  loadMaterials() {
    this.materialsService.GetMaterials().subscribe((materials) => {
      this.materials = materials;
      console.log(materials);
      
    });
  }

  createFormGroup()
  {
    return new FormGroup({
    id: new FormControl(),
    title:  new FormControl(),
    priority:  new FormControl(),
    projectDescription:  new FormControl(),
    totalProjectPrice:  new FormControl(),
    userGuid: new FormControl(),
    isActive: new FormControl(true),
    isComplete: new FormControl(false),
      }
    )
  }

  updateForm(project:Project)
  {   
    if (this.project==undefined)
    {
      this.form.setValue({title: project.title, id: undefined});
    }
    else
    {
      console.log("Updating form with project:", project);
    this.form.setValue({
      title: project.title,
      id: project.id,
      priority: project.priority,
      projectDescription: project.projectDescription,
      totalProjectPrice: project.totalProjectPrice,
      userGuid: project.userGuid,
      isActive: project.isActive !== false,
      isComplete: project.isComplete === true,
    });

    }
}

  loadProject(projectId: number) { 
    this.projectService.getProject(projectId).subscribe((project) => {
      this.project = project; 
       this.updateForm(project);
     this.projecTasksCount = this.project.projectTasks.length;
 
    // this.projecContractorsCount= this.project.contractors.length;  
    
      this.dataSource = new MatTableDataSource<ProjectMaterial>(project.materials);
      console.log(this.dataSource)
        console.log(this.project.materials);
      //this.dataSource = project.materials;
       console.log(project);
       
       // set default tab after project loads (index 0 = first tab)
       if (this.tabGroup) {
         this.tabGroup.selectedIndex = 0;
       } else {
         // If ViewChild isn't ready yet, schedule a microtask to set it once available
         setTimeout(() => {
           if (this.tabGroup) {
             this.tabGroup!.selectedIndex = 0;
           }
         }, 0);
       }

      this.isLoadingResults = false;
      this.cdr.markForCheck();
      setTimeout(() => this.cdr.detectChanges(), 0);
    });
 
  }

 

  
  sortIcon(property: string) {
    if (property === this.sortProperty) {
        return this.sortOrder === 1 ? '☝️' : '👇';
    }
    return '';
}

sortListBy(property: string) {
   
  this.sortListOrder = property === this.sortListProperty ? (this.sortListOrder * -1) : 1;
  this.sortListProperty = property;
  this.items = [...this.materials.sort((a: any, b: any) => {
      // sort comparison function
      let result = 0;
      if (a[property] < b[property]) {
          result = -1;
      }
      if (a[property] > b[property]) {
          result = 1;
      }
      return result * this.sortListOrder;
  })];
}

sortListIcon(property: string) {
  if (property === this.sortListProperty) {
      return this.sortListOrder === 1 ? '☝️' : '👇';
  }
  return '';
}
  sortBy(property: string) {
     
    this.sortOrder = property === this.sortProperty ? (this.sortOrder * -1) : 1;
    this.sortProperty = property;
    this.items = [...this.materials.sort((a: any, b: any) => {
        // sort comparison function
        let result = 0;
        if (a[property] < b[property]) {
            result = -1;
        }
        if (a[property] > b[property]) {
            result = 1;
        }
        return result * this.sortOrder;
    })];
}

sortByProjectMaterial(property: string) {
     
  
}
  saveProject() {
    if (this.form.valid) {
      const assignedProject: Project = Object.assign({}, this.form.value);
      assignedProject.id = this.project.id;
      assignedProject.userGuid = this.project.userGuid;

      // Labor total: use in-memory cache if the Labor tab was visited, else fall back to stored value
      const cachedLabor = this.laborService.currentEntries;
      const laborTotal = cachedLabor.length > 0
        ? cachedLabor.reduce((sum, e) => sum + (e.totalCost || 0), 0)
        : (this.project.totalLaborPrice || 0);

      let materialTotal = 0;
      (this.project.materials || []).forEach((m: ProjectMaterial) => materialTotal += m.cost);

      assignedProject.totalLaborPrice = +laborTotal;
      assignedProject.totalMaterialPrice = +materialTotal;
      assignedProject.totalProjectPrice = +(materialTotal + laborTotal);
      assignedProject.currentProjectPrice = +this.getcurrentProjectPrice(this.project);

      this.projectService.updateProject(assignedProject).subscribe(() => {
        console.log('project updated successfully!');
        if (assignedProject.id !== undefined) {
          this.loadProject(assignedProject.id);
        }
        this.openSnackBar();
      });
    }
  }

onTabChange(_event: MatTabChangeEvent): void {
  const scrollY = window.scrollY;
  // Immediate restore (desktop); also restore after Material's animation (mobile)
  requestAnimationFrame(() => window.scrollTo(0, scrollY));
  setTimeout(() => window.scrollTo(0, scrollY), 280);
}

openSnackBar() {
 
  this.snackBar.open('Successfully Saved Project', '', {
    duration: 3000
  });
}
editMaterialinProject(material:ProjectMaterial)
{

}
  removeMaterialfromProject(material:ProjectMaterial) 
  {
    
  
    this.projectMaterialService.deleteMaterial(material)
    .subscribe(res => {
       
        
        this.isLoadingResults = true;
        console.log('Project edited successfully!');
       
         
       this.loadProject(this.project?.id);
       
      }, (err) => {
        console.log(err);
        this.isLoadingResults = false;
      });  
  }

  toggleAvailbleMaterials()
  {
    if(this.showAvailbleMaterials)
    {
      this.showAvailbleMaterials = false;
    }
    else
    {
      this.showAvailbleMaterials = true;
    }

  }
  addMaterialToProjectMaterials(material:Materials)
  {
    
    let newProjectMaterial: ProjectMaterial  = Object.assign(material); 
    let newProject: Project   = Object.assign({}, this.project); 

    //Go Back and Fix
   newProjectMaterial.id = 0 ; //= newProject.id; 
    newProjectMaterial.productCategory = material.productCategory;
    newProjectMaterial.productDescription = material.productDescription;
    newProjectMaterial.productName = material.productName;
    newProjectMaterial.productPrice = material.productPrice;
    newProjectMaterial.productWeight = material.productWeight;
    newProjectMaterial.subCategory = material.subCategory; 
    newProjectMaterial.qty = 5;
    newProjectMaterial.cost = material.productPrice * newProjectMaterial.qty;
     //console.log(this.name,this.empoloyeeID);
   
  //  newProject.materials = newProject.materials || [];
    //  if(newProject.ProjectMaterial == null)
    // {
    //     this.ProjectMaterials.fill(newProjectMaterial);
  
    // }  
    newProject.materials.push(newProjectMaterial);
    newProject.totalProjectPrice = this.getTotalCost(newProject);

    let materialssum: number = 0;
    newProject.materials.forEach(a => materialssum += a.cost);

    newProject.totalMaterialPrice = materialssum;
  
    this.projectService.updateProject(newProject)
    .subscribe(res => {
       
        
        this.isLoadingResults = false;
        console.log('Project edited successfully!');
        this.loadProject(this.project?.id);
      }, (err) => {
        console.log(err);
        this.isLoadingResults = false;
      });
  }
  getcurrentProjectPrice(newProject: Project): number {
    let sum: number = 0;
    newProject.materials.forEach(a => sum += a.purchasedTotal);

    const paidLabor = this.laborService.currentEntries
      .filter(e => e.isPaid)
      .reduce((total, e) => total + (e.totalCost || 0), 0);

    return sum + paidLabor;
  }

  onLaborPaidChanged(): void {
    if (!this.project?.id) { return; }
    const newCurrentSpend = +this.getcurrentProjectPrice(this.project);
    this.project = { ...this.project, currentProjectPrice: newCurrentSpend };
    this.projectService.updateProject(this.project).subscribe({
      next: () => this.cdr.markForCheck()
    });
  }



  getTotalCost(newProject: Project): number {
    let sum: number = 0;
    newProject.materials.forEach(a => sum += a.cost);
    sum += newProject.totalLaborPrice || 0;
    return sum;
  }



  editRow(element: ProjectMaterial) {
   
    this.editedRow = element; // {element };
  }

  cancelEdit(element: ProjectMaterial) {
    // Restore original values
    this.editedRow = undefined;
  }

  UpdateProjectTotals()
  {


    let newProject: Project   = Object.assign({}, this.project); 

    newProject.totalProjectPrice = +this.getTotalCost(newProject);
    let materialssum: number = 0;
    newProject.materials.forEach(a => materialssum += a.cost); 
    newProject.totalMaterialPrice = materialssum;
  
    this.projectService.updateProject(newProject)
    .subscribe(res => {
       
        
        this.isLoadingResults = false;
        console.log('Project edited successfully!');
        this.loadProject(this.project?.id);
      }, (err) => {
        console.log(err);
        this.isLoadingResults = false;
      });
  }


  // saveEdit(element: ProjectMaterial) {
  //   // Update data source with edited values
  //   let materials: ProjectMaterial[]= this.project.materials!;
  //   let m:ProjectMaterial | any
  //   m = materials.find(a=> a.id = element.id);
  //   m.productPrice = +element.productPrice;
  //   m.qty = +element.qty;
  //   m.cost = +m.productPrice * m.qty;
    

  //   if (m !== undefined) {
  //     m.productName = element.productName;
  //     this.projectMaterialService.editMaterial(m)
  //   .subscribe(res => {
       
        
  //       this.isLoadingResults = false;
  //       console.log('Project edited successfully!');
  //       this.loadProject(this.project?.id);
  //     }, (err) => {
  //       console.log(err);
  //       this.isLoadingResults = false;
  //     });
  //   }
  //   debugger
  //   this.UpdateProjectTotals();
  //   this.editedRow = undefined;
  // }
}
